import { render, staticRenderFns } from "./FooterEnrolment.vue?vue&type=template&id=23526320&"
import script from "./FooterEnrolment.vue?vue&type=script&lang=js&"
export * from "./FooterEnrolment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports